import React from 'react'
import styles from './styles.module.css'

import ColorChip from '../color-chip'
import { useSelector } from '../../stores/dashboard.store'

export default ({ data }) => {
    const colors = useSelector(x => x?.colors)

    if (colors === undefined) return null

    return (
        <div className={styles.nodeInfo}>
            <div style={{ display: 'flex', gap: 5 }}>
                {
                    data?.isSmart && (
                        <ColorChip label="Smart Node" color={[255, 78, 183]} />
                    )
                }
                {
                    (data?.requiredConnection || "").length > 0 && (
                        <ColorChip label={data?.requiredConnection} color={[255, 78, 183]} />
                    )
                }
            </div>

            <div>
                <div className={styles.moreInfoHeader}>Description</div>
                <div>
                    {data?.docs?.trim()}
                </div>
            </div>

            <div>
                <div className={styles.moreInfoHeader}>Inputs</div>
                <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                    {data?.inputs?.map(x => (
                        <ColorChip label={x?.name} color={colors[x?.type]} />
                    ))}
                </div>
            </div>

            <div>
                <div className={styles.moreInfoHeader}>Outputs</div>
                <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                    {data?.outputs?.map(x => (
                        <ColorChip label={x?.name} color={colors[x?.type]} />
                    ))}
                </div>
            </div>
        </div>
    )
}